import { colors } from "@areahub/theme";
import { Geometry } from "@turf/turf";
import { type LayerProps } from "react-map-gl";
export function getHazardMapLayerStyle(
  geometry?: Geometry,
  color?: string,
): LayerProps {
  if (!geometry) {
    return {
      id: "point",
      type: "circle",
      paint: {
        "circle-radius": 10,
        "circle-color": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          colors.muiGreen[600],
          color || colors.blue[800],
        ],
        "circle-stroke-color": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          colors.blueGray[800],
          "transparent",
        ],
      },
    };
  }
  switch (geometry.type) {
    case "Point":
      return {
        id: "point",
        type: "circle",
        paint: {
          "circle-radius": 10,
          "circle-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            colors.muiGreen[600],
            color || colors.blue[800],
          ],
          "circle-stroke-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            colors.blueGray[800],
            "transparent",
          ],
        },
      };
    case "LineString":
      return {
        id: "line",
        type: "line",
        paint: {
          "line-width": 5,
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            colors.muiGreen[600],
            color || colors.blue[800],
          ],
          "line-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            1,
            0.75,
          ],
        },
      };
    case "MultiLineString":
      return {
        id: "line",
        type: "line",
        paint: {
          "line-width": 5,
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            colors.muiGreen[600],
            color || colors.blue[800],
          ],
          "line-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            1,
            0.75,
          ],
        },
      };
    case "Polygon":
      return {
        id: "fill",
        type: "fill",
        paint: {
          "fill-color": color || colors.blue[300],
          "fill-opacity": 0.25,
        },
      };
    case "MultiPolygon":
      return {
        id: "fill",
        type: "fill",
        paint: {
          "fill-color": color || colors.blue[800],
          "fill-opacity": 0.5,
        },
      };

    default:
      return {
        id: "point",
        type: "circle",
        paint: {
          "circle-radius": 10,
          "circle-color": color || colors.blue[800],
        },
      };
  }
}
